// extracted by mini-css-extract-plugin
export default {"button":"cultures_button__BNjP7","buttonText":"cultures_buttonText__gGj6j","active":"cultures_active__yZsR-"};